<template>
  <div>
    <header class="sm:px-6 lg:px-8">
        <h1 class="text-2xl font-bold leading-tight text-gray-900 mb-0">
          {{ this.$route.name }}
        </h1>
    </header>
    <main>
      <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div class="px-4 py-3 sm:px-0">
          <div class="flex flex-col">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <DataTable
                    :value="projects"
                    :paginator="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                    :rows="8"
                    :rowsPerPageOptions="[8,10,20,50]"
                    :auto-layout="true"
                    stripedRows
                    class="p-datatable-striped admin-projects-table"
                  >
                    <Column field="id" header="# ID"></Column>
                    <Column field="title" header="TITRE ET DESCRIPTION" body-class="truncate">
                      <template #body="slotProps">
                        <router-link :to="{ name: 'Admin Project Details', params: { projectId: slotProps.data.id } }">
                          <a class="text-sm w- text-gray-900 group-hover:underline">
                            {{ slotProps.data.title }}
                          </a>
                          <div class="text-sm text-gray-500 max-w-sm whitespace-pre-wrap line-clamp">
                            {{ slotProps.data.description || "Aucune description disponible" }}
                          </div>
                        </router-link>
                      </template>
                    </Column>
                    <Column field="team" header="ÉQUIPE">
                      <template #body="slotProps">
                        <div class="flex -space-x-2 team-column">
                          <img v-for="member in slotProps.data.members.first3"
                              class="inline-block h-8 w-8 rounded-full ring-2 ring-white p-1 member-avatar"
                              :src="avatar_face"
                              :alt="member.id"
                              :style="{ 'background-color': member.color }"
                              v-tooltip.top="member.username"
                          />
                          <div v-if="slotProps.data.members.remaining.length" class="inline-block h-8 w-8 rounded-full text-center text-xs
                          flex items-center justify-center ring-2 ring-white bg-gray-100 cursor-pointer relative" @click="showRemainingMembers(slotProps.data.members.remaining, $event)">
                            +{{ slotProps.data.members.remaining.length }}
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column field="created_at" header="DATE DE CRÉATION"></Column>
                    <Column field="updated_at" header="DERNIÈRE MISE À JOUR"></Column>
                    <Column :exportable="false" style="min-width:8rem">
                      <template #body="slotProps">
                        <i @click="editProject(slotProps.data)" class="pi pi-pencil cursor-pointer p-mr-5 p-mb-2"></i>
                        <i @click="deleteProject(slotProps.data.id)" class="pi pi-trash cursor-pointer"></i>
                      </template>
                    </Column>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OverlayPanel ref="op" appendTo="body">
        <ul>
          <li v-for="member in selectedRemainingMembers">{{ member.username }}</li>
        </ul>
      </OverlayPanel>
      <EditProjectDialog v-if="isEditDialogOpen" :is-open="isEditDialogOpen" v-on:update:is-open="isEditDialogOpen = $event" />
    </main>
  </div>
</template>

<script>
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import InputText from "primevue/inputtext"
import OverlayPanel from 'primevue/overlaypanel';
import EditProjectDialog from "../../components/Admin/Projects/EditProjectDialog"
import avatar_face from "~/assets/img/avatars/face-1.svg";

export default {
  name: 'Projects',
  components: {
    EditProjectDialog,
    DataTable,
    Column,
    InputText,
    OverlayPanel,
  },
  mounted() {
    this.$store.dispatch('adminProjects/fetchAll')
  },
  data: () => ({
    isEditDialogOpen: false,
    avatar_face: avatar_face,
    selectedRemainingMembers: [],
  }),
  computed: {
    projects() {
      const projects = this.$store.state.adminProjects.entities
      const list = []

      projects.forEach(project => {
        const members = [...project.members]
        const first3 = members.splice(0, 3)
        const projectList = {
          ...project,
          members: {
            all: project.members,
            first3,
            remaining: members,
          }
        }
        list.push(projectList)
      })
      return list
    },
  },
  methods: {
    async editProject(project) {
      await this.$store.dispatch('adminProjects/fetchById', project.id)
      /** Sort the emails in two arrays for administrators and participants */
      this.isEditDialogOpen = true
    },
    hideDialog() {
      this.isEditDialogOpen = false
    },
    log(message) {
      console.log(message)
    },
    async deleteProject(projectId) {
      this.$confirm.require({
        message: 'Êtes-vous sûr de vouloir supprimer ce projet ?',
        header: 'Confirmation de suppression',
        icon: 'pi pi-exclamation-triangle',
		acceptLabel: 'Oui',
		rejectLabel: 'Non',
        accept: async () => {
          await this.$store.dispatch('adminProjects/delete', projectId)
          this.$toast.add({
            severity:'success', summary: 'Projet supprimé', detail:'Le projet a été supprimé avec succès', life: 3000
          });
        }
      })
    },
    showRemainingMembers(remaining, event) {
      this.selectedRemainingMembers = remaining
      this.$refs.op.toggle(event);
    }
  },
}
</script>

<style scoped>

</style>
